import { useState } from 'react';
import MeasurementUnits from '../../../Layout/MeasurementUnits';
import withMarkProduct from '../../MarkProduct/withMarkProduct';

const ShoppingListProduct = ({ product, handleMarkProduct }) => {
  const [isBought, setIsBought] = useState(product.isBought);
  const [hide, setHide] = useState(false);

  const designSystem = localStorage.getItem('developerOptionsDesignSystem') || 'brand';

  const toggleDone = () => {
    if (product.isBought) {
      setIsBought(false);
      setTimeout(() => setHide(true), 0);
      setTimeout(() => handleMarkProduct('unMark', product), 100);
    } else {
      setIsBought(true);

      setTimeout(() => setHide(true), 0);
      setTimeout(() => handleMarkProduct('mark', product), 100);
    }
  };

  let myClassName = '';

  if (product.isBought) {
    if (isBought) {
      myClassName = 'done show';
    } else if (hide) {
      myClassName = 'hide-up';
    } else {
      myClassName = '';
    }
  } else if (isBought) {
    if (hide) {
      myClassName = 'done hide-down';
    } else {
      myClassName = 'done';
    }
  } else {
    myClassName = 'show';
  }

  return (
    <li>
      <button
        type="button"
        onClick={toggleDone}
        className={myClassName}
        data-design-system={designSystem}
      >
        {product.name}
        <MeasurementUnits measurements={product.measurements} />
      </button>
    </li>
  );
};

export default withMarkProduct(ShoppingListProduct);
